import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react-lite';

export interface ImportanceIconProps {
    importance: string;
}

const styles = require('./ComposeTop.scss');

const ImportanceIcon = observer((props: ImportanceIconProps) => {
    const { importance } = props;
    if (!importance || importance == 'Normal') {
        return null;
    }

    const isHighImportance = importance == 'High';
    return (
        <Icon
            key="importance"
            className={isHighImportance ? styles.importanceIcon : null}
            iconName={isHighImportance ? ControlIcons.Important : ControlIcons.Down}
        />
    );
});

export default ImportanceIcon;
